module.exports = __webpack_public_path__ + "img/ring_g_i_null_null@3x.5158fa1b.png";